"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("react");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_expansion_1 = require("@ryerson/frontend.expansion");

var frontend_application_1 = require("@ryerson/frontend.application");

var content_1 = require("./content");

var frontend_common_1 = require("@ryerson/frontend.common");

var ImageContainer = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\ttext-align: center;\n"])));
var BodyCopy = styled_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tpadding: 40px 0px;\n"])));
var HelpCopy = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tpadding: 20px;\n"])));

var Joe404 = function Joe404(_ref) {
  var dataTestId = _ref.dataTestId,
      location404 = _ref.location404;
  var language = (0, frontend_application_1.useApplication)().localization.language;
  var attemptedUrl = "";

  if (typeof window !== "undefined") {
    attemptedUrl = window.location.href;
  } //trigger google analytics event on 404 page


  (0, react_1.useEffect)(function () {
    (0, frontend_common_1.sendGAEvent)(frontend_common_1.GoogleAnalyticsEventName.NOT_FOUND, {
      action: "view",
      value: attemptedUrl
    });
  }, []);
  return (0, jsx_runtime_1.jsx)(frontend_layout_1.ContentSection, {
    type: "primary",
    dataTestId: dataTestId,
    children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Grid, {
      children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Row, {
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.Column, {
          md: 5,
          children: (0, jsx_runtime_1.jsx)(ImageContainer, {
            children: (0, jsx_runtime_1.jsx)("img", {
              src: "/static-assets/images/joe/metalDetector.png",
              width: "60%"
            })
          })
        }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Column, {
          md: 7,
          children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            type: "primary",
            variant: "h2",
            children: content_1.content.title[language]
          }), (0, jsx_runtime_1.jsxs)(BodyCopy, {
            children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              type: "primary",
              variant: "p",
              children: content_1.content.body1[language]
            }), (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
              type: "primary",
              variant: "p",
              children: [content_1.content.body2[language], " ", (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                to: location404 === "store" ? "/" : "/store",
                gatsby: location404 === "store",
                children: content_1.content.body2Link[language]
              }), "?"]
            })]
          }), (0, jsx_runtime_1.jsx)(frontend_expansion_1.ExpansionBox, {
            bodyType: "secondary",
            headerType: "secondary",
            header: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              type: "secondary",
              children: content_1.content.needHelp[language]
            }),
            clickableHeader: true,
            defaultOpen: true,
            children: (0, jsx_runtime_1.jsx)(frontend_expansion_1.Expander, {
              children: (0, jsx_runtime_1.jsxs)(HelpCopy, {
                children: [(0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                  type: "secondary",
                  variant: "p",
                  children: [content_1.content.help1[language], " ", (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                    to: "/contact-us",
                    gatsby: location404 === "marketing",
                    children: content_1.content.help1Link[language]
                  }), "."]
                }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                  type: "secondary",
                  variant: "p",
                  children: content_1.content.help2[language]
                }), (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
                  type: "secondary",
                  variant: "p",
                  size: "xs",
                  children: ["Technical Details from a 404...", (0, jsx_runtime_1.jsx)("br", {}), "Location: ", location404, (0, jsx_runtime_1.jsx)("br", {}), "Timestamp: ", new Date().toISOString(), (0, jsx_runtime_1.jsx)("br", {}), "Attempted URL: ", attemptedUrl]
                })]
              })
            })
          })]
        })]
      })
    })
  });
};

exports.default = Joe404;